import { useRef, useEffect } from 'react';
import { formatCurrency } from '@atc/string-fns';
import { DebouncedInput } from 'reaxl';
import MaskedTextInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import clsx from 'clsx';
import ndsConstants from '../ndsConstants.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const {
  currencyMaskOptions
} = ndsConstants;
function CalculatorInput(_ref) {
  let {
    name,
    label,
    inputProps,
    value,
    disableInput = false,
    supportingLink,
    tabName = 'finance',
    showTextField = false
  } = _ref;
  const inputRef = useRef([]);
  useEffect(() => {
    queueMicrotask(() => {
      try {
        inputRef.current?.tradeInInput?.inputElement?.focus();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error focusing input:', error);
      }
    });
  }, []);
  const {
    className,
    ...inputPropsRest
  } = inputProps;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [showTextField ? /*#__PURE__*/jsx("div", {
      className: "row",
      children: /*#__PURE__*/jsxs("div", {
        className: "col-xs-12 text-size-300 display-flex justify-content-between padding-vertical-3",
        "data-cmp": "listingPrice",
        children: [label, /*#__PURE__*/jsx("span", {
          className: "margin-left-auto",
          children: value ? `${formatCurrency(value)}` : ''
        })]
      })
    }) : /*#__PURE__*/jsx(DebouncedInput, {
      ...inputPropsRest,
      className: clsx(className, {
        'text-bold': !!value
      }),
      maxLength: "10",
      inputMode: "numeric",
      component: MaskedTextInput,
      mask: createNumberMask(currencyMaskOptions),
      ref: element => {
        inputRef.current[name] = element;
      },
      onChangeDuration: 1000,
      layout: "inside",
      name: name,
      id: `${name}-${tabName}`,
      value: value ? `${formatCurrency(value)}` : '',
      placeholder: "$0",
      disabled: disableInput,
      label: label,
      onFocus: event => {
        setTimeout(() => event?.target?.select(), 0);
      }
    }), !!supportingLink && !disableInput && supportingLink()]
  });
}
export { CalculatorInput as default };
